// The main track magnet's mark (spec magnet-ripple, D6): a small magnet in the 16 px before 00:00
// of the magnetic track's band, so no column is added. Its switch is one of the timeline toolbar's
// switches, after Preview axis (`EditorScreen.tsx`).
import { Magnet } from "lucide-react";

import classes from "./magnet.module.css";

/** The magnetic track's mark, before 00:00 on its band: drawn only, as the switch says it. */
export function MagnetMark() {
  return <Magnet className={classes.mark} size={12} aria-hidden data-main-track />;
}
